
import { makeStyles, createStyles, Grid } from "@material-ui/core";
import React from 'react';
import { TPositionAlign } from "./PanelBase";
import { PanelToolBar } from "./PanelToolbar";

export interface IPanelToolBarFullProps {
    positionAlign?: TPositionAlign,
    toolTipButton?: string,
    startOpened?: boolean,
    top?: string,
}
export const PanelToolBarFull: React.FC<IPanelToolBarFullProps> = ({
    positionAlign = 'right',
    toolTipButton,
    children,
    startOpened = false,
    top
}) => {

    return (
        <PanelToolBar positionAlign={positionAlign} toolTipButton={toolTipButton} startOpened={startOpened} top={top}>
            <Grid
                container
                direction="column"
                justify="flex-start"
                alignItems="center"
            >
                {children}
            </Grid>
        </PanelToolBar>
    )
}

export const PanelToolBarFullSeparator: React.FC = () => {

    const useStyles = makeStyles(() =>
        createStyles({
            separator: {
                marginTop: '0px',
                marginBottom: '0px',
                borderTop: '1px dashed',
                width: '90%'
            },
        }),
    );

    const styles = useStyles();

    return (
        <hr className={styles.separator} />
    )
}